// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","844":"component---src-pages-privacy-js"}[chunkId] + "-" + {"351":"b5f6ae33483a74b98a76","678":"512f58ab9a2d781e7853","844":"42ce75d770e0b22f99d0"}[chunkId] + ".js";
};